export const MODIFY_STATUS = 'MODIFY_STATUS';

export function modifyStatus(status){
    return{
        type: MODIFY_STATUS,
        mainState: {
            status: status
        }
    }
}